/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import ReservationEvent from '../../event/ReservationEvent'
import { AutoActionLogState } from '../state/AutoActionLogState'

class AutoActionLogsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchAutoActionLog:
        return List(payload.auto_action_logs.map(model => new AutoActionLogState().merge(model)))
      default:
        return state
    }
  }
}

export default new AutoActionLogsStore()
